import { useEffect, useState } from "react";

const useCustomClaims = (user) => {
  const [claims, setClaims] = useState([]);

  useEffect(() => {
    const getClaims = async () => {
      if (user) {
        const tokenResult = await user.getIdTokenResult();
        setClaims(tokenResult.claims);
      }
    };

    getClaims();
  }, [user]);

  return { claims };
};

export default useCustomClaims;
